import { render, staticRenderFns } from "./AppMentionsDropdown.vue?vue&type=template&id=4bde7120&"
import script from "./AppMentionsDropdown.vue?vue&type=script&lang=js&"
export * from "./AppMentionsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports